// LLM generated - Model Claude 4 Sonnet
import { AssetType } from '~/services/contests/enums/contests-assets.enums';

export const uploadImageAssetConfig = {
  [AssetType.CONTEST_THUMBNAIL]: {
    fileSizeLimit: {
      min: 0,
      max: 1 * 1024 * 1024,
      bytes: 1,
    },
    fileDimensionLimit: {
      width: {
        min: null,
        max: null,
      },
      height: {
        min: null,
        max: null,
      },
      ratio: {
        min: 0.8,
        max: 1.2,
      },
    },
    suggestedDimension: {
      width: 256,
      height: 256,
    },

    mimeTypes: ['image/jpeg', 'image/png'],
    formats: ['png', 'jpg', 'jpeg'],
  },
  [AssetType.CONTEST_BANNER]: {
    fileSizeLimit: {
      min: 0,
      max: 4 * 1024 * 1024,
      bytes: 4,
    },
    fileDimensionLimit: {
      width: {
        min: null,
        max: null,
      },
      height: {
        min: null,
        max: null,
      },
      ratio: {
        min: 1.2,
        max: 2,
      },
    },
    suggestedDimension: {
      width: 2880,
      height: 170,
    },
    mimeTypes: ['image/jpeg', 'image/png'],
    formats: ['png', 'jpg', 'jpeg'],
  },
};
